var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { getSums } from '@debbie/common/dist/economy/billing/organize';
import { c, h } from '@debbie/cortex/dist';
import * as billingAPI from '@debbie/cortex/dist/api/billing';
import { billingCollectionsKey, billingKey } from '@debbie/cortex/dist/billings';
import q from '@debbie/cortex/dist/query';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { Badge, Button, CopyToClipboard, Modal, Money, PlaceholderLoader, RadioSelect, Table, } from '..';
import THEME from '../../theme';
import { getBillingIdentity } from '../Billing';
import CreditorEconomyBillingSettings from '../economy/CreditorEconomyBillingSettings';
import { Col, Row } from '../Grid';
import { ArrowRight, Edit, ExternalLink, FilePlus, Send } from '../Icons';
import SubPanel from '../SubPanel';
import ExcelPreview from './ExcelPreview';
import PDFPreview from './PDFPreview';
import UIPreview from './UIPreview';
import { useCreditor } from '@debbie/cortex/dist/creditors';
var Option;
(function (Option) {
    Option["Preview"] = "Preview";
    Option["PDF"] = "PDF";
    Option["Excel"] = "Excel";
})(Option || (Option = {}));
const BillingPreview = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const { billing } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const creditorLoadable = useCreditor(props.billing.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const tenant = useSelector(selectTenant);
    const [selectedOption, _setSelectedOption] = React.useState(localStorage.getItem('billingPreviewOption') ||
        Option.Preview);
    const [sendingBilling, setSendingBilling] = React.useState(false);
    const [addingToPayouts, setAddingToPayouts] = React.useState(false);
    const [editCreditorBillingSettings, setEditCreditorBillingSettings] = React.useState(false);
    const setSelectedOption = (option) => {
        localStorage.setItem('billingPreviewOption', option);
        _setSelectedOption(option);
    };
    const identity = getBillingIdentity(props.billing, lang);
    const sums = billing && getSums(billing);
    const balance = sums ? sums.balance : null;
    const payout = typeof balance === 'number' ? balance < 0 : null;
    return (React.createElement("div", null,
        React.createElement("div", null, billing && creditor ? (React.createElement(React.Fragment, null,
            React.createElement("h2", null,
                identity,
                " -",
                ' ',
                moment(props.billing.date).format(THEME.DATE_FORMAT_SHORT)),
            creditor && (React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(SubPanel, { header: React.createElement(React.Fragment, null,
                            lang.billing.recipient,
                            React.createElement("div", { style: { float: 'right' } }, !props.billingSelector &&
                                site === Site.Caseworker && (React.createElement(Button, { size: "mini", theme: billing.billingEmailed
                                    ? 'secondary'
                                    : undefined, disabled: !(((_a = creditor.billingEmails) === null || _a === void 0 ? void 0 : _a.to) ||
                                    ((_b = creditor.billingEmails) === null || _b === void 0 ? void 0 : _b.cc) ||
                                    ((_c = creditor.billingEmails) === null || _c === void 0 ? void 0 : _c.bcc)), loading: sendingBilling, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                    try {
                                        setSendingBilling(true);
                                        if (!billing.billingEmailed ||
                                            confirm(lang.billing.billingAlreadySentAlert)) {
                                            yield billingAPI.sendBillings([
                                                props.billing.billingId,
                                            ]);
                                        }
                                        q.invalidate([
                                            billingKey(billing.billingId),
                                            billingCollectionsKey(),
                                        ]);
                                    }
                                    catch (error) {
                                        console.error(error);
                                        alert('Error');
                                    }
                                    setSendingBilling(false);
                                }) },
                                billing.billingEmailed
                                    ? lang.billing.billingSent
                                    : lang.billing.sendBilling,
                                ' ',
                                React.createElement(Send, { style: {
                                        height: '14px',
                                        width: '14px',
                                        transform: 'translateY(1px)',
                                        margin: '-0.2em 0 -0.2em 0.2em',
                                    } }))))) },
                        React.createElement(Row, null,
                            React.createElement(Col, { width: "5" },
                                React.createElement("h3", { style: { marginBottom: '0' } },
                                    creditor.name,
                                    ' ',
                                    site === Site.Caseworker && (React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/creditors/${creditor.creditorId}`) }))),
                                React.createElement("p", { style: { marginTop: '0.2em' } },
                                    React.createElement(CopyToClipboard, { text: creditor.id }, creditor.id)),
                                (((_d = creditor.settings.billingTextFieldSettings) === null || _d === void 0 ? void 0 : _d.underCreditorName) ||
                                    ((_e = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _e === void 0 ? void 0 : _e.underCreditorName)) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, ((_f = creditor.settings.billingTextFieldSettings) === null || _f === void 0 ? void 0 : _f.underCreditorName) ||
                                    ((_g = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _g === void 0 ? void 0 : _g.underCreditorName))),
                                ((_h = creditor.address) === null || _h === void 0 ? void 0 : _h.address) && (React.createElement("p", null,
                                    creditor.address.address,
                                    React.createElement("br", null),
                                    creditor.address.coAddress && (React.createElement(React.Fragment, null,
                                        creditor.address.coAddress,
                                        React.createElement("br", null))),
                                    creditor.address.zipcode,
                                    " ",
                                    creditor.address.city,
                                    React.createElement("br", null),
                                    creditor.address.country))),
                            site === Site.Caseworker && (React.createElement(Col, { width: "7" },
                                React.createElement(Emails, { type: "TO", emails: (_j = creditor.billingEmails) === null || _j === void 0 ? void 0 : _j.to, onClick: () => setEditCreditorBillingSettings(true) }),
                                React.createElement(Emails, { type: "CC", emails: (_k = creditor.billingEmails) === null || _k === void 0 ? void 0 : _k.cc, onClick: () => setEditCreditorBillingSettings(true) }),
                                React.createElement(Emails, { type: "BCC", emails: (_l = creditor.billingEmails) === null || _l === void 0 ? void 0 : _l.bcc, onClick: () => setEditCreditorBillingSettings(true) }))))),
                    React.createElement(SubPanel, { header: React.createElement(React.Fragment, null,
                            lang.billing.information,
                            React.createElement("div", { style: { float: 'right' } }, !props.billingSelector &&
                                payout &&
                                site === Site.Caseworker && (React.createElement(Button, { size: "mini", theme: billing.addedToPayouts
                                    ? 'secondary'
                                    : undefined, disabled: billing.addedToPayouts ||
                                    !(((_m = creditor.bankAccountDetails) === null || _m === void 0 ? void 0 : _m.registrationNumber) &&
                                        ((_o = creditor.bankAccountDetails) === null || _o === void 0 ? void 0 : _o.accountNumber)), loading: addingToPayouts, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                    try {
                                        setAddingToPayouts(true);
                                        if (!billing.addedToPayouts) {
                                            yield billingAPI.addToPayouts(props.billing.billingId);
                                        }
                                        q.invalidate([
                                            billingKey(billing.billingId),
                                            billingCollectionsKey(),
                                        ]);
                                    }
                                    catch (error) {
                                        console.error(error);
                                        alert('Error');
                                    }
                                    setAddingToPayouts(false);
                                }) },
                                billing.addedToPayouts
                                    ? lang.billing.addedToPayouts
                                    : lang.billing.addToPayouts,
                                ' ',
                                React.createElement(FilePlus, { style: {
                                        height: '14px',
                                        width: '14px',
                                        transform: 'translateY(1px)',
                                        margin: '-0.2em 0 -0.2em 0.2em',
                                    } }))))) }, payout !== null &&
                        (payout ? (React.createElement(React.Fragment, null,
                            React.createElement("p", null,
                                React.createElement("b", null,
                                    React.createElement(Money, { currency: billing.currency, amount: -sums.balance })),
                                ' ',
                                lang.billing.amountWillBeWithdrawnToAccount,
                                ' ',
                                ((_p = creditor.bankAccountDetails) === null || _p === void 0 ? void 0 : _p.registrationNumber) &&
                                    ((_q = creditor.bankAccountDetails) === null || _q === void 0 ? void 0 : _q.accountNumber) ? (React.createElement("b", null,
                                    creditor.bankAccountDetails.registrationNumber,
                                    ' ',
                                    creditor.bankAccountDetails.accountNumber)) : ('-'),
                                ' ',
                                site === Site.Caseworker && (React.createElement(Edit, { style: { cursor: 'pointer' }, onClick: () => setEditCreditorBillingSettings(true) }))),
                            (((_r = creditor.settings.billingTextFieldSettings) === null || _r === void 0 ? void 0 : _r.endWhenSendingPayment) ||
                                ((_s = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _s === void 0 ? void 0 : _s.endWhenSendingPayment)) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, ((_t = creditor.settings.billingTextFieldSettings) === null || _t === void 0 ? void 0 : _t.endWhenSendingPayment) ||
                                ((_u = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _u === void 0 ? void 0 : _u.endWhenSendingPayment))))) : (React.createElement(React.Fragment, null,
                            React.createElement("p", null,
                                React.createElement("b", null,
                                    React.createElement(Money, { currency: billing.currency, amount: sums.balance })),
                                ' ',
                                lang.billing.amountShouldBePaidToAccount,
                                ' ',
                                ((_v = tenant === null || tenant === void 0 ? void 0 : tenant.bankAccountDetails) === null || _v === void 0 ? void 0 : _v.registrationNumber) &&
                                    ((_w = tenant === null || tenant === void 0 ? void 0 : tenant.bankAccountDetails) === null || _w === void 0 ? void 0 : _w.accountNumber) ? (React.createElement("b", null,
                                    tenant.bankAccountDetails.registrationNumber,
                                    ' ',
                                    tenant.bankAccountDetails.accountNumber,
                                    tenant.bankAccountDetails.bankName
                                        ? ` (${tenant.bankAccountDetails.bankName})`
                                        : '')) : ('-')),
                            React.createElement("p", null,
                                lang.billing.invoiceNo,
                                " ",
                                React.createElement("b", null, billing.id || 'X'),
                                ' ',
                                lang.billing.specifiedByBankTransfer),
                            React.createElement("p", null,
                                lang.billing.paymentTerms,
                                ' ',
                                creditor.paymentTerms.paymentDays || '-',
                                ' ',
                                lang.billing.daysAndBillingDate,
                                ":",
                                ' ',
                                React.createElement("b", null, creditor.paymentTerms.paymentDays
                                    ? moment(billing.date)
                                        .add(creditor.paymentTerms.paymentDays, 'days')
                                        .format(THEME.DATE_FORMAT_SHORT)
                                    : '-')),
                            (((_x = creditor.settings.billingTextFieldSettings) === null || _x === void 0 ? void 0 : _x.endWhenReceivingPayment) ||
                                ((_y = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _y === void 0 ? void 0 : _y.endWhenReceivingPayment)) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, ((_z = creditor.settings.billingTextFieldSettings) === null || _z === void 0 ? void 0 : _z.endWhenReceivingPayment) ||
                                ((_0 = tenant === null || tenant === void 0 ? void 0 : tenant.settings.billingTextFields) === null || _0 === void 0 ? void 0 : _0.endWhenReceivingPayment)))))))),
                React.createElement(Col, { width: "6" },
                    React.createElement(BillingOverview, { billing: billing })))))) : (React.createElement(PlaceholderLoader, null))),
        React.createElement("hr", null),
        React.createElement("div", null,
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.Preview), active: selectedOption === Option.Preview, label: lang.billing.preview }),
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.PDF), active: selectedOption === Option.PDF, label: lang.billing.PDFPreview }),
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.Excel), active: selectedOption === Option.Excel, label: lang.billing.ExcelPreview })),
        React.createElement("div", { style: { padding: `${THEME.GRID_SPACING}px 0` } }, (() => {
            switch (selectedOption) {
                case Option.Preview:
                    return (React.createElement(UIPreview, { billing: props.billing, billingSelector: props.billingSelector, closeModal: props.closeModal }));
                case Option.PDF:
                    return (React.createElement(PDFPreview, { billing: props.billing, billingSelector: props.billingSelector }));
                case Option.Excel:
                    return (React.createElement(ExcelPreview, { billing: props.billing, billingSelector: props.billingSelector }));
            }
        })()),
        editCreditorBillingSettings && creditor && (React.createElement(Modal, { onToggle: () => setEditCreditorBillingSettings(!editCreditorBillingSettings) },
            React.createElement(CreditorEconomyBillingSettings, { creditor: creditor })))));
};
export default BillingPreview;
const BillingOverview = (props) => {
    const lang = useSelector((s) => s.lang);
    const sums = getSums(props.billing);
    return (React.createElement("div", null,
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("th", null,
                    React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, props.billing.currency)),
                React.createElement("th", { style: { textAlign: 'right' } }, lang.billing.amount),
                React.createElement("th", { style: { textAlign: 'right', width: '85px' } }, lang.billing.vat)),
            !!sums.depositSum && (React.createElement(React.Fragment, null,
                React.createElement("tr", null,
                    React.createElement("td", null, lang.billing.deposits),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.depositSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.forPayout),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.payoutSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.collectionCommission),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.collectionCommissionSum })),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.collectionCommissionVatSum }))),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.overpayments),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.overpaymentsSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")))),
            !!(sums.feesSum + sums.feesVatSum) && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.fees),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.feesSum })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.feesVatSum })))),
            !!(sums.disbursementsSum + sums.disbursementsVatSum) && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.disbursements),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.disbursementsSum })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.disbursementsVatSum })))),
            !!sums.vatSum && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.otherVat),
                React.createElement("td", { style: { textAlign: 'right' } }),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.vatSum }))))),
        React.createElement("p", { style: { textAlign: 'right' } },
            lang.billing.subtotal,
            ": ",
            React.createElement(Money, { amount: sums.subTotal }),
            React.createElement("br", null),
            React.createElement("small", null,
                lang.billing.vat,
                ": ",
                React.createElement(Money, { amount: sums.vat })),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("b", null,
                lang.billing.total,
                ": ",
                React.createElement(Money, { amount: sums.balance })))));
};
const StyledEmailsWrapper = styled.div `
  display: flex;
  justify-content: space-between;

  background-color: #f5f5f5;
  border-radius: 3px;
  margin-bottom: 0.5em;
  cursor: pointer;
  font-size: 0.8em;
`;
const StyledEmailType = styled.div `
  font-weight: bold;
  color: ${THEME.COLOR_ACCENT};
  width: 40px;
  padding: 8px 5px 8px 8px;
`;
const StyledEmails = styled.div `
  padding: 8px 5px;
  flex-grow: 1;
`;
const Emails = (props) => {
    return (React.createElement(StyledEmailsWrapper, { onClick: props.onClick },
        React.createElement(StyledEmailType, null, props.type),
        React.createElement(StyledEmails, null, props.emails || '-'),
        React.createElement(Edit, { style: {
                margin: '9px',
            } })));
};
//# sourceMappingURL=BillingPreview.js.map